import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PageContainer } from '@guildeducationinc/recess';
import { AnimateWrapper } from '@src/components/AnimateWrapper';
import { HeaderBar } from '@src/components/HeaderBar';
import { RoleBanner } from '@src/components/Manager/RoleBanner/RoleBanner';
import { ContainerContext } from '@src/contexts';
import { useAuth } from '@src/hooks/useAuth';
import { useCurrentClientConfig } from '@src/hooks/useCurrentClientConfig';
import { useSierraUserData } from '@src/hooks/useSierraUserData';
import classNames from 'classnames';
import { ScrollToTop, Sierra } from 'pe-core-frontend';
import { useContext, useEffect } from 'react';
import 'react-js-cron/dist/styles.css';
import { useLocation } from 'react-router-dom';
import './App.scss';
import { Footer } from './components/Footer';
function App() {
    const { showFooter, setShowFooter, isFullscreen } = useContext(ContainerContext);
    const { currentUser, isSuperuser, isManager } = useAuth();
    const sierraUserData = useSierraUserData();
    const location = useLocation();
    const isTasksPage = isManager && location.pathname.includes('/tasks');
    // Check if Sierra is enabled for this client via client config
    const { clientConfig } = useCurrentClientConfig();
    const enableSierra = clientConfig?.extraData?.enableSierra === true;
    useEffect(() => {
        if (currentUser) {
            setShowFooter(true);
        }
    }, [currentUser, setShowFooter]);
    return (_jsxs(_Fragment, { children: [_jsx(ScrollToTop, {}), enableSierra && sierraUserData && _jsx(Sierra, { userData: sierraUserData }), _jsxs("div", { children: [_jsx(HeaderBar, {}), _jsxs("main", { className: classNames(isFullscreen ? 'fullscreen' : showFooter && currentUser ? 'hasFooter' : '', isTasksPage && 'approvalTasks'), children: [isTasksPage && _jsx(RoleBanner, { className: 'approvalTasksBanner' }), _jsx(PageContainer, { withoutTopPadding: true, className: isSuperuser ? 'full-width' : '', children: _jsx("div", { children: _jsx(AnimateWrapper, {}) }) })] }), _jsx(Footer, {})] })] }));
}
export default App;
